<template>
    <div id="app" @click="">
        <router-view :systems="systems" :updateLED="updateLED" :connectSystem="connectSystem" :saveName="saveName"/>
    </div>
</template>

<script>
export default {
    name: 'App',
    methods: {
        connectSystem(id, connectCallback){
            this.systems.push({
                id,
                connectCallback,
                led: false
            })
            this.mqttClient.subscribe(`$aws/things/${id}/shadow/get/accepted`);
            setTimeout(()=>{
                this.mqttClient.publish(`$aws/things/${id}/shadow/get`, '');
            }, 100);
            console.log(`Trying to connect to ${id}`)
        },
        updateLED(system){
            this.mqttClient.publish(`$aws/things/${system.id}/shadow/update`, JSON.stringify({
                "state":{
                    "desired":{
                        "led":system.led
                    }
                }
            }));
        },
        saveName(system, newName){
            this.mqttClient.publish(`$aws/things/${system.id}/shadow/update`, JSON.stringify({
                "state":{
                    "reported":{
                        "name": newName
                    }
                }
            }));
        },
        mqttClientConnectHandler() {
           console.log('connect');
        },
        mqttClientReconnectHandler() {
           console.log('reconnect');
        },
        mqttClientMessageHandler(topic, payload) {
            console.log('message: ' + topic + ':' + payload.toString());
            const match = topic.match(/\$aws\/things\/(.*)\/shadow\/(.*)\/accepted/);
            const id = match[1];
            let system = this.systems.find(system=>system.id === id);
            if(match[2] === 'get'){
                if(system.connectCallback){
                    system.connectCallback();
                }
                this.mqttClient.unsubscribe(`$aws/things/${id}/shadow/get/accepted`);
                this.mqttClient.subscribe(`$aws/things/${id}/shadow/update/accepted`);
            }
            let data = JSON.parse(payload.toString());
            console.log(data)
            if(data.state.reported){
                this.$set(system, 'state', Object.assign({}, system.state, data.state.reported));
                this.$set(system, 'metadata', Object.assign({}, system.metadata, data.metadata.reported));
                system.led = system.state.led;
            }
        }
    },
    data(){
        return {
            mqttClient: null,
            systems: [
                /*{  
                    "name":"SN 1805-004",
                    "id":"",
                    "led":false,
                    "message":"",
                    "timestamp":1527602116,
                    "e":2,
                    "w":0
                },*/



/*
                {  
                    "name":"SN 1805-003",
                    "id":"esp8266_17E8BA",
                    "led":false,
                    "message":"",
                    "timestamp":1531500889,
                    state: false
                }*/



                /*,
                {  
                    "name":"esp8266_EDF93A",
                    "id":"",
                    "led":false,
                    "message":"",
                    "timestamp":1528110278,
                    "e":2,
                    "w":0
                },
                {  
                    "name":"esp8266_1A1CF4",
                    "id":"",
                    "led":false,
                    "message":"",
                    "timestamp":1532943249,
                    "e":0,
                    "w":0
                },
                {  
                    "name":"esp8266_EE00DD",
                    "id":"",
                    "led":false,
                    "message":"",
                    "timestamp":1528109132,
                    "e":3,
                    "w":2
                },
                {  
                    "name":"esp32_1A9178",
                    "id":"",
                    "led":false,
                    "message":"",
                    "timestamp":1531007615,
                    "e":3,
                    "w":3
                },
                {  
                    "name":"esp8266_3A1B15",
                    "id":"",
                    "led":false,
                    "message":"",
                    "timestamp":1532937316,
                    "e":0,
                    "w":0
                },
                {  
                    "name":"esp8266_158F93",
                    "id":"",
                    "led":false,
                    "message":"",
                    "timestamp":1529067995,
                    "e":3,
                    "w":2
                }*/
            ]
        }
    },
    mounted(){



var AWS = require('aws-sdk');
var AWSIoTData = require('aws-iot-device-sdk');
var AWSConfiguration = require('./aws/configuration.js');

console.log('Loaded AWS SDK for JavaScript and AWS IoT SDK for Node.js');

//
// Remember our current subscription topic here.
//
var currentlySubscribedTopic = 'subscribe-topic';

//
// Remember our message history here.
//
var messageHistory = '';

//
// Create a client id to use when connecting to AWS IoT.
//
var clientId = 'qualle-webapp-' + (Math.floor((Math.random() * 100000) + 1));

//
// Initialize our configuration.
//
AWS.config.region = AWSConfiguration.region;

AWS.config.credentials = new AWS.CognitoIdentityCredentials({
   IdentityPoolId: AWSConfiguration.poolId
});

//
// Create the AWS IoT device object.  Note that the credentials must be 
// initialized with empty strings; when we successfully authenticate to
// the Cognito Identity Pool, the credentials will be dynamically updated.
//
this.mqttClient = AWSIoTData.device({
   //
   // Set the AWS region we will operate in.
   //
   region: AWS.config.region,
   host:AWSConfiguration.host,
   //
   // Use the clientId created earlier.
   //
   clientId: clientId,
   //
   // Connect via secure WebSocket
   //
   protocol: 'wss',
   //
   // Set the maximum reconnect time to 8 seconds; this is a browser application
   // so we don't want to leave the user waiting too long for reconnection after
   // re-connecting to the network/re-opening their laptop/etc...
   //
   maximumReconnectTimeMs: 8000,
   //
   // Enable console debugging information (optional)
   //
   debug: true,
   //
   // IMPORTANT: the AWS access key ID, secret key, and sesion token must be 
   // initialized with empty strings.
   //
   accessKeyId: '',
   secretKey: '',
   sessionToken: ''
});

//
// Attempt to authenticate to the Cognito Identity Pool.  Note that this
// example only supports use of a pool which allows unauthenticated 
// identities.
//
var cognitoIdentity = new AWS.CognitoIdentity();
AWS.config.credentials.get((err, data)=>{
   if (!err) {
      console.log('retrieved identity: ' + AWS.config.credentials.identityId);
      var params = {
         IdentityId: AWS.config.credentials.identityId
      };
      cognitoIdentity.getCredentialsForIdentity(params, (err, data)=>{
         if (!err) {
            //
            // Update our latest AWS credentials; the MQTT client will use these
            // during its next reconnect attempt.
            //
            this.mqttClient.updateWebSocketCredentials(data.Credentials.AccessKeyId,
               data.Credentials.SecretKey,
               data.Credentials.SessionToken);
         } else {
            console.log('error retrieving credentials: ' + err);
            alert('error retrieving credentials: ' + err);
         }
      });
   } else {
      console.log('error retrieving identity:' + err);
      alert('error retrieving identity: ' + err);
   }
});



this.mqttClient.on('connect', this.mqttClientConnectHandler);
this.mqttClient.on('reconnect', this.mqttClientReconnectHandler);
this.mqttClient.on('message', this.mqttClientMessageHandler);
let deviceIds = JSON.parse(localStorage.deviceIds || '[]');

deviceIds.forEach(deviceId=>{
    this.connectSystem(deviceId);
})


}
}
</script>

<style>
#app {
  font-family: Arial;
}
</style>



// WEBPACK FOOTER //
// src/App.vue